import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Configurations from './settings';

declare global {
  interface Window {
    UET: any;
    uetq: any[];
    dataLayer: any[];
  }
}

const TrackingAndRedirects: React.FC = () => {
  const location = useLocation();

  /*IE REDIRECT (RUN FIRST)*/
  useEffect(() => {
    const { origin } = window.location;
    const userAgent = window.navigator.userAgent;

    const isOldIE = userAgent.includes('MSIE ') || userAgent.includes('Trident/');

    if (isOldIE) {
      window.location.href = `${origin}/app/ienotsupported.html`;
    }
  }, []);

  /* GOOGLE TAG MANAGER */
  useEffect(() => {
    const gtmId = Configurations.REACT_APP_APP_GTM;
    if (!gtmId) return;

    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js',
    });

    if (!document.querySelector(`script[src*="googletagmanager.com/gtm.js?id=${gtmId}"]`)) {
      const gtmScript = document.createElement('script');
      gtmScript.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
      gtmScript.async = true;
      document.head.appendChild(gtmScript);
    }
  }, []);

  /* GTM SPA PAGEVIEWS */
  useEffect(() => {
    if (!window.dataLayer) return;

    window.dataLayer.push({
      event: 'virtual_pageview',
      page_path: location.pathname,
      page_location: window.location.href,
    });
  }, [location]);

  /* BING UET (REGISTRATION PAGE) */
  useEffect(() => {
    if (location.pathname !== '/registration') return;
    if (window.UET) return;
    (function (w: any, d: Document, t: string, r: string, u: string) {
      w[u] = w[u] || [];

      const loadUET = () => {
        const o: any = {
          ti: '97110000',
          enableAutoSpaTracking: true,
        };
        o.q = w[u];
        w[u] = new w.UET(o);
        w[u].push('pageLoad');
      };

      const script = d.createElement(t) as HTMLScriptElement;
      script.src = r;
      script.async = true;
      script.onload = loadUET;

      const firstScript = d.getElementsByTagName(t)[0];
      firstScript.parentNode!.insertBefore(script, firstScript);
    })(window, document, 'script', 'https://bat.bing.com/bat.js', 'uetq');
  }, [location]);

  /* GOOGLE OPTIMIZE*/
  useEffect(() => {
    if (!document.querySelector('script[src*="googleoptimize.com/optimize.js"]')) {
      const optimizeScript = document.createElement('script');
      optimizeScript.src = 'https://www.googleoptimize.com/optimize.js?id=OPT-T9NDZSL';
      optimizeScript.async = true;
      document.head.appendChild(optimizeScript);
    }
  }, []);

  /* /app/agencies URL NORMALIZATION */
  useEffect(() => {
    const { href } = window.location;

    if (!href.toLowerCase().includes('/app/agencies')) return;

    let newUrl = href;
    let redirect = false;

    if (/[A-Z]/.test(newUrl)) {
      newUrl = newUrl.toLowerCase();
      redirect = true;
    }

    if (!newUrl.endsWith('/')) {
      newUrl += '/';
      redirect = true;
    }

    if (redirect) {
      window.location.replace(newUrl);
    }
  }, []);

  return null;
};

export default TrackingAndRedirects;
